import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';

import { InputPhoneNumber, InputText, Button } from 'shared/components/UI';

// eslint-disable-next-line css-modules/no-unused-class
import s from './../LeasingOnlineBanner.css';

class UserDataForm extends React.Component {
  static propTypes = {
    userName: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    changeHandler: PropTypes.func.isRequired,
    onSubmitHandler: PropTypes.func.isRequired,
    disableBtnLeasing: PropTypes.bool,
  };

  static defaultProps = {
    toggleLeasingModal: () => {},
    disableBtnLeasing: false,
  };

  render() {
    const {
      userName,
      phone,
      errorMessage,
      successMessage,
      t,
      changeHandler,
      onSubmitHandler,
      disableBtnLeasing,
    } = this.props;

    const disabledBtn = disableBtnLeasing || !userName || !phone;

    return (
      <div className={s.containerCenter}>
        <form className={s.requestForm}>
          <InputPhoneNumber name={'phone'} value={phone} changeHandler={changeHandler} />
          <InputText
            name={'userName'}
            value={userName}
            placeholder={userName || t('Ваше имя')}
            changeHandler={changeHandler}
          />

          {(errorMessage || successMessage) &&
            <span
              className={cx(
                { [s.errorMessage]: errorMessage },
                { [s.successMessage]: successMessage },
              )}
            >
              {t(errorMessage || successMessage)}
            </span>}
          <Button
            disabled={disabledBtn}
            type="button"
            onClick={e => onSubmitHandler(e, 'call')}
            text="Получить консультацию"
          />
        </form>
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(UserDataForm));



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/UserDataForm/UserDataForm.js